module.exports = __webpack_public_path__ + "img/contact-ludwigwappling.31632e6c.png";